var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInventory(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 5.66669,
    y: 7.08325,
    width: 22.6667,
    height: 22.6667,
    rx: 2,
    stroke: "#3C4469"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.6667 2.83325L22.6667 9.33325C22.6667 10.2761 22.6667 10.7475 22.3738 11.0404C22.0809 11.3332 21.6095 11.3332 20.6667 11.3332L13.3334 11.3333C12.3905 11.3333 11.9191 11.3333 11.6262 11.0404C11.3334 10.7475 11.3334 10.2761 11.3334 9.33325L11.3334 2.83326",
    stroke: "#3C4469",
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.75 19.8333L21.25 19.8333",
    stroke: "#3C4469",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInventory);
export default __webpack_public_path__ + "static/media/inventory.2dab610982dccff84e8a344b8c7ff26c.svg";
export { ForwardRef as ReactComponent };